import type { IconSvgObject } from './types';

const TriangleIcon: IconSvgObject = [
  ["path", { d: "M20.3493 16.9696L13.7483 5.08783C12.9863 3.71622 11.0137 3.71622 10.2517 5.08783L3.65068 16.9696C2.91009 18.3026 3.87403 19.9409 5.39899 19.9409H18.6009C20.1259 19.9409 21.0898 18.3026 20.3493 16.9696Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TriangleIcon;
